$(() => {
  $('form.edit_school').find('select[multiple="multiple"]').select2()
  $('.new-school-entity').select2()
  $('form.new_school').on('click','#manual-entry',function(e){
    e.preventDefault()
    $('form.new_school [disabled]').removeAttr('disabled')
    $('form.new_school #school_name').focus()
  })
})
